import React from "react";
import { Checkbox, FormControlLabel, FormGroup } from "@mui/material";

export default function CheckboxesAnswer({ options, answers }) {
  if (!!!answers) {
    return (
      <>
        {options.map((answer, index) => (
          <FormGroup key={index}>
            <FormControlLabel
              disabled
              control={<Checkbox />}
              className="flex items-center w-full ml-2 md:py-4 py-2 pl-5 m-2  space-x-2 border-2 cursor-pointer bg-black/5 border-black/10 rounded-xl"
              label={answer}
            />
          </FormGroup>
        ))}
      </>
    );
  }

  return (
    <>
      {!!options ? (
        <>
          {options.map((answer, index) => (
            <div key={index}>
              {answers[index] === true ? (
                <FormGroup key={index}>
                  <FormControlLabel
                    //TODO: burası açılabilir
                    // key={index}
                    disabled
                    className="flex items-center w-full ml-2 md:py-4 py-2 pl-5 m-2  space-x-2 border-2 cursor-pointer bg-blue-300 border-black/10 rounded-xl"
                    control={<Checkbox />}
                    label={answer}
                  />
                </FormGroup>
              ) : (
                <FormGroup>
                  <FormControlLabel
                    disabled
                    key={index}
                    control={<Checkbox />}
                    className="flex items-center w-full ml-2 md:py-4 py-2 pl-5 m-2  space-x-2 border-2 cursor-pointer bg-black/5 border-black/10 rounded-xl"
                    label={answer}
                  />
                </FormGroup>
              )}
            </div>
          ))}
        </>
      ) : (
        ""
      )}
    </>
  );
}
